// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- First-visit welcome overlay ---
   Reuses the .modal-overlay / .login-modal shell and .login-btn styles from the global
   stylesheet. Only the welcome-specific layout (headline, benefits list, CTA block) lives here. */

.welcome-modal {
  max-width: 30rem;
  text-align: center;
}

.welcome-modal__title {
  margin: 0 0 0.5rem;
  font-size: 1.5rem;
  line-height: 1.2;
}

.welcome-modal__subtitle {
  margin: 0 0 1.25rem;
  opacity: 0.85;
  line-height: 1.4;
}

.welcome-modal__benefits {
  list-style: none;
  margin: 0 0 1.5rem;
  padding: 0;
  text-align: left;
}

.welcome-benefit {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.5rem 0;
}

.welcome-benefit__icon {
  font-size: 1.35rem;
  line-height: 1.4;
  flex: 0 0 auto;
}

.welcome-benefit__text {
  display: flex;
  flex-direction: column;
}

.welcome-benefit__label {
  font-weight: 600;
}

.welcome-benefit__hint {
  font-size: 0.85rem;
  opacity: 0.75;
  line-height: 1.35;
}

.welcome-modal__actions {
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
}

.welcome-modal__cta {
  width: 100%;
  font-size: 1.05rem;
  padding: 0.75rem 1rem;
}

.welcome-modal__reassure {
  margin: 0;
  font-size: 0.85rem;
  opacity: 0.7;
}

.welcome-modal__later {
  margin-top: 0.25rem;
  background: none;
  border: none;
  padding: 0.25rem;
  color: inherit;
  opacity: 0.65;
  cursor: pointer;
  font-size: 0.9rem;
  text-decoration: underline;
}

.welcome-modal__later:hover {
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/components/welcome-modal/welcome-modal.css"],"names":[],"mappings":"AAAA;;kGAEkG;;AAElG;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* --- First-visit welcome overlay ---\r\n   Reuses the .modal-overlay / .login-modal shell and .login-btn styles from the global\r\n   stylesheet. Only the welcome-specific layout (headline, benefits list, CTA block) lives here. */\r\n\r\n.welcome-modal {\r\n  max-width: 30rem;\r\n  text-align: center;\r\n}\r\n\r\n.welcome-modal__title {\r\n  margin: 0 0 0.5rem;\r\n  font-size: 1.5rem;\r\n  line-height: 1.2;\r\n}\r\n\r\n.welcome-modal__subtitle {\r\n  margin: 0 0 1.25rem;\r\n  opacity: 0.85;\r\n  line-height: 1.4;\r\n}\r\n\r\n.welcome-modal__benefits {\r\n  list-style: none;\r\n  margin: 0 0 1.5rem;\r\n  padding: 0;\r\n  text-align: left;\r\n}\r\n\r\n.welcome-benefit {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.75rem;\r\n  padding: 0.5rem 0;\r\n}\r\n\r\n.welcome-benefit__icon {\r\n  font-size: 1.35rem;\r\n  line-height: 1.4;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.welcome-benefit__text {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.welcome-benefit__label {\r\n  font-weight: 600;\r\n}\r\n\r\n.welcome-benefit__hint {\r\n  font-size: 0.85rem;\r\n  opacity: 0.75;\r\n  line-height: 1.35;\r\n}\r\n\r\n.welcome-modal__actions {\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.welcome-modal__cta {\r\n  width: 100%;\r\n  font-size: 1.05rem;\r\n  padding: 0.75rem 1rem;\r\n}\r\n\r\n.welcome-modal__reassure {\r\n  margin: 0;\r\n  font-size: 0.85rem;\r\n  opacity: 0.7;\r\n}\r\n\r\n.welcome-modal__later {\r\n  margin-top: 0.25rem;\r\n  background: none;\r\n  border: none;\r\n  padding: 0.25rem;\r\n  color: inherit;\r\n  opacity: 0.65;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  text-decoration: underline;\r\n}\r\n\r\n.welcome-modal__later:hover {\r\n  opacity: 0.9;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
